<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-input v-model="keywords" placeholder="搜索"></el-input>
        <el-button @click="_getList" type="primary">搜索</el-button>
        <!-- <el-button @click="export2Excel" ref="exportData">导出为xls</el-button> -->
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow"
        >
        </el-pagination>
      </div>
      <div class="userTable">
        <el-table
          ref="multipleTable"
          :data="userDatas"
          tooltip-effect="dark"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column prop="id" label="会员ID" width="80">
          </el-table-column>
          <el-table-column prop="userName" label="会员账号" width="100">
          </el-table-column>
          <el-table-column prop="phone" label="手机号" width="120">
          </el-table-column>
          <el-table-column
            prop="vip"
            :formatter="getVipText"
            label="会员等级"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.cashCoupon"
            label="U券"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.deliveryMoney"
            label="配送账户"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.uvalue"
            label="Q值总量"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.totalUValue"
            label="市场总Q值"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.totalEarnings"
            label="收益总额"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="name" label="所属店铺" width="200">
          </el-table-column>
          <el-table-column prop="userAccountVo.balance" label="余额" width="80">
          </el-table-column>
          <el-table-column prop="insertTime" label="注册时间" width="160">
          </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <!-- <el-button
              size="mini"
              @click="handleShowPush(scope.row)">推荐用户列表</el-button>
            <el-button
              size="mini"
              @click="handleShowDetail(scope.row)">详情</el-button>
            <el-button
             size="mini"
             @click="handleEdit(scope.$index, scope.row)">修改资料</el-button> -->
              <el-button size="mini" @click="handleShowOrder(scope.row)"
                >查看订单</el-button
              >
              <el-button
                size="mini"
                @click="handleFreeze(scope.row, 1)"
                v-if="scope.row.state == 0"
                >冻结账号</el-button
              >
              <el-button
                size="mini"
                @click="handleFreeze(scope.row, 0)"
                v-if="scope.row.state == 1"
                >解冻账号</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除账号</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="用户详情"
        :visible.sync="detailDialogVisible"
        :append-to-body="true"
        width="80%"
        :modal="false"
      >
        <el-table
          ref="multipleTable"
          :data="userDetail"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column prop="id" label="会员ID" width="160">
          </el-table-column>
          <el-table-column prop="userName" label="会员账号" width="160">
          </el-table-column>
          <el-table-column prop="insertTime" label="注册时间" width="220">
          </el-table-column>
          <el-table-column
            prop="userAccountVo.balance"
            label="US余额"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="recommendNumber" label="推荐人数" width="120">
          </el-table-column>
          <el-table-column prop="referralCode" label="邀请码" width="120">
          </el-table-column>
          <el-table-column prop="insertTime" label="注册时间" width="120">
          </el-table-column>
          <el-table-column prop="inviterName" label="推荐人" width="120">
          </el-table-column>
          <el-table-column
            prop="userAccountVo.principal"
            label="本金"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.earnings"
            label="收益"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.shareBonus"
            label="共享红利"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.sharingRevenue"
            label="分享收益"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.teamSubsidies"
            label="团队津贴"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.manageSubsidies"
            label="管理津贴"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.serviceEarnings"
            label="服务收益"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.score"
            label="购物赠送积分"
            width="140"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.crowdfundingScore"
            label="众筹积分"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="userAccountVo.walletAddress"
            label="钱包地址"
            width="120"
          >
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="直推用户列表"
        :visible.sync="pushDialogVisible"
        :append-to-body="true"
        width="60%"
        :modal="false"
      >
        <el-table
          ref="multipleTable"
          :data="pushUserDatas"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column prop="id" label="会员ID" width="160">
          </el-table-column>
          <el-table-column prop="userName" label="会员账号" width="160">
          </el-table-column>
          <el-table-column prop="insertTime" label="注册时间" width="220">
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pushDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="修改资料"
        :visible.sync="editDialogVisible"
        :append-to-body="true"
        width="40%"
        :modal="false"
      >
        <el-form label-position="left" label-width="80px" :model="controlData">
          <el-form-item label="账号:">
            <el-input v-model="controlData.userName"></el-input>
          </el-form-item>
          <el-form-item label="密码:">
            <el-input v-model="controlData.password" type="password"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="edit()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="freezeDialogVisible"
        width="20%"
        center
        :append-to-body="true"
      >
        <span>确定要冻结当前用户吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="freezeDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="freezeUser()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="20%"
        :append-to-body="true"
        center
      >
        <span>确定要删除当前用户吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="deleteUser()">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="配送订单"
        :visible.sync="deliveryOrderSyn"
        :append-to-body="true"
        width="50%"
        height="50%"
        :modal="false"
      >
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="待配送" name="601"></el-tab-pane>
          <el-tab-pane label="已配送" name="603"></el-tab-pane>
        </el-tabs>
        <el-table
          ref="multipleTable"
          :data="orderList"
          tooltip-effect="dark"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column prop="orderNumber" label="订单号" width="200">
          </el-table-column>
          <el-table-column prop="distributionCode" label="配送码" width="200">
          </el-table-column>
          <el-table-column prop="title" label="商品名称" width="200">
          </el-table-column>
          <el-table-column prop="specialSpec" label="商品规格" width="200">
          </el-table-column>
          <el-table-column prop="number" label="购买数量" width="200">
          </el-table-column>
          <el-table-column prop="unitPrice" label="单价" width="200">
          </el-table-column>
          <el-table-column prop="userName" label="下单人" width="200">
          </el-table-column>
          <el-table-column prop="phone" label="手机号" width="200">
          </el-table-column>
          <el-table-column prop="storeName" label="店铺名称" width="200">
          </el-table-column>
        </el-table>
        <!-- <div slot="footer" class="dialog-footer">
          <el-button @click="deliveryOrderSyn = false">取 消</el-button>
          <el-button type="primary" @click="deliveryOrderSyn = false">确 定</el-button>
        </div> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  getAllUser,
  saveUser,
  deleteUser,
  freezeUser,
  getPushUser,
  selectDeliveryOrderList
} from "api/request";
import { getDepartment } from "api/post";
import { ERR_OK } from "api/config";
import { formatDate, loadingInstance, Success, Error } from "common/js/util";
export default {
  components: {
    MSidebar,
    MHeader
  },
  data() {
    return {
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      keywords: null,
      paginationShow: false,
      detailDialogVisible: false,
      pushDialogVisible: false,
      editDialogVisible: false,
      freezeDialogVisible: false,
      deleteDialogVisible: false,
      controlData: {},
      userDetail: [],
      userDatas: [],
      pushUserDatas: [],
      multipleSelection: [],
      orderList: [],
      deliveryOrderSyn: false,
      activeName: "601",
      userId: -1
    };
  },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/"
      });
    } else {
      this._getList();
    }
  },
  methods: {
    handleShowOrder(row) {
      this.activeName = "601";
      var param = {
        pageSize: 100,
        pageNum: 1,
        state: this.activeName,
        orderType: 3,
        userId: row.id
      };
      this.userId = row.id;
      selectDeliveryOrderList(param).then(res => {
        if (res.status === ERR_OK) {
          this.orderList = res.data.records;
          this.deliveryOrderSyn = true;
        } else {
          Error(this, res);
        }
      });
    },
    handleClick() {
      var param = {
        pageSize: 100,
        pageNum: 1,
        state: this.activeName,
        orderType: 3,
        userId: this.userId
      };
      selectDeliveryOrderList(param).then(res => {
        if (res.status === ERR_OK) {
          this.orderList = res.data.records;
          this.deliveryOrderSyn = true;
        } else {
          Error(this, res);
        }
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChange(val) {
      console.log(val);
      this.pageNum = val;
      this.userDatas = [];
      this._getList();
    },
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.userDatas[index];
    },
    handleEdit(index, row) {
      this.editDialogVisible = true;
      this.controlData = this.userDatas[index];
    },
    handleShowDetail(row) {
      this.detailDialogVisible = true;
      this.userDetail = [row];
    },
    handleShowPush(row) {
      this.pushDialogVisible = true;
      this._getPushList(row.id);
    },
    getVipText(row) {
      // 0.不是会员    1.vip     2.银卡   3.金卡    4.钻卡
      if (row.vip < 0) {
        return "非代理";
      }
      // let vipMap = {
      //   0: '体验代理',
      //   1: '金牌代理',
      //   2: '总代理',
      //   3: '联创代理',
      //   4: '董事'
      // }
      let vipMap = {
        0: "体验会员",
        1: "vip会员",
        2: "金牌会员",
        3: "钻石会员",
        4: "总代会员"
      };
      return vipMap[row.vip];
    },
    edit() {
      let param = {
        userid: getUserInfo.userid,
        saveId: this.controlData.userid,
        password: this.controlData.password
      };
      loadingInstance(Loading);
      saveUser(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    handleFreeze(data, status) {
      let param = {
        state: status,
        id: data.id
      };
      loadingInstance(Loading);
      freezeUser(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    deleteUser() {
      let param = {
        userid: getUserInfo.userid
      };
      loadingInstance(Loading);
      removeUser(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    _getList() {
      let param = {
        content: this.keywords,
        current: this.pageNum,
        size: this.pageSize,
        type: 1
      };
      loadingInstance(Loading);
      getAllUser(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.userDatas = res.data.records;
          this.totalNum = res.data.total;
          if (res.data.pages > 1) {
            this.paginationShow = true;
          }
        } else {
          Error(this, res);
        }
      });
    },
    _getPushList(id) {
      let param = {
        current: 1,
        size: 100,
        userId: id
      };
      loadingInstance(Loading);
      getPushUser(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.pushUserDatas = res.data.records;
        } else {
          Error(this, res);
        }
      });
    },
    export2Excel() {
      var exportList = this.multipleSelection;
      let arr = [];
      for (var i = 0; i < this.exportList.length; i++) {
        let obj = {};
        obj.id = this.exportList[i].id;
        obj.userName = this.exportList[i].userName;
        obj.insertTime = this.exportList[i].insertTime;
        obj.balance = this.exportList[i].userAccountVo.balance;
        obj.recommendNum = this.exportList[i].recommendNum;
        arr.push(obj);
      }
      require.ensure([], () => {
        const { exportJsonToExcel } = require("../../vendor/Export2Excel");
        const tHeader = [
          "会员ID",
          "会员账号",
          "注册时间",
          "US余额",
          "推荐人数"
        ];
        const filterVal = [
          "id",
          "userName",
          "insertTime",
          "balance",
          "recommendNum"
        ];
        const list = arr;
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, "用户列表");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style scoped>
.userOperate {
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.userTable {
  padding: 10px;
  position: relative;
}
</style>
<style>
.userOperate .el-input {
  width: 180px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}

.userOperate .el-button {
  width: 100px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/store/delivery.vue